import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { AlertSearchComponent } from './alert-search.component'

const ALERT_SEARCH_ROUTES: Routes = [{
    path: '', component: AlertSearchComponent
}];

export const ALERT_SEARCH_ROUTING  = RouterModule.forChild(ALERT_SEARCH_ROUTES);